<template>
  <BoxContext>
    <BoxTabs />
    <RouterView />
  </BoxContext>
</template>

<script lang="ts" setup>
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import BoxContext from '@/components/deepbox/box/BoxContext.vue'
import BoxTabs from '@/components/deepbox/box/BoxTabs.vue'

const { permissions } = useAuthorizationContext()

definePage({
  props: true,
  meta: {
    breadcrumbLabelKey: '',
  },
})

defineProps({
  organizationId: {
    type: String,
    required: true,
  },
  typeId: {
    type: String,
    required: true,
  },
  boxId: {
    type: String,
    required: true,
  },
})

usePageAccess(computed(() => !permissions.canViewBoxes))
</script>
